import React from 'react'
import classNames from 'classnames'

const CardHeader = props => {
  return (
    <div>
      <div className={classNames('card_header', props.className)}>
        {props.children}
      </div>
    </div>
  )
}
export default CardHeader
